// src/components/ui/Toast.jsx
// Standalone Toast component — Layout.jsx imports this directly
import React from 'react';

export default function Toast({ message, type = 'success' }) {
  if (!message) return null;
  const colors = { success: '#10b981', danger: '#ef4444', error: '#ef4444', warning: '#f59e0b', info: '#3b82f6' };
  const icons  = { success: '✓', danger: '✗', error: '✗', warning: '⚠', info: 'ℹ' };
  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24,
      background: '#1a1a2e', color: '#fff',
      padding: '14px 20px', borderRadius: 12,
      boxShadow: '0 8px 30px rgba(0,0,0,0.25)',
      display: 'flex', alignItems: 'center', gap: 10,
      fontSize: 14, fontFamily: "'DM Sans', sans-serif",
      zIndex: 9999, maxWidth: 380,
      borderLeft: `4px solid ${colors[type] || colors.success}`,
      animation: 'slideInToast 0.3s ease',
    }}>
      <span style={{ color: colors[type] || colors.success, fontWeight: 700, fontSize: 16 }}>
        {icons[type] || '✓'}
      </span>
      {message}
      <style>{`
        @keyframes slideInToast {
          from { transform: translateX(100%); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }
      `}</style>
    </div>
  );
}
